<template>
    <occupants-get
        :page="page"
        :archived="archived"
        :tenancy="$route.query.tenancy"
        v-slot="{
            data: occupants,
            meta,
            error,
            is_loading,
            has_loaded,
            get
        }"
    >
        <div v-if="!has_loaded || error">
            <base-loading
                :error="error"
                :retry="get"
                class="py-6"
            />

            <error-modal
                v-if="error"
                :error="error"
            />
        </div>

        <div v-else>
            <div class="mb-6 bg-white rounded shadow">
                <header class="flex items-center px-4 py-3 sm:px-6 md:py-3 border-b-3 border-grey-bg">
                    <div class="flex-grow">
                        <h1 class="text-lg font-normal">Tenants</h1>
                    </div>
                    <div class="w-6 h-6 mr-3">
                        <base-svg
                            v-show="is_loading"
                            name="icon-loading"
                            class="w-full h-full fill-current text-grey"
                        />
                    </div>

                    <router-link
                        :to="{ name: $router.fix('dashboard.*.occupants.create') }"
                        class="btn btn-blue btn-with-icon"
                    >
                        <div class="flex items-center w-full h-full">
                            <base-svg
                                name="icon-add-circle"
                                class="w-6 h-6 md:mr-2"
                            />

                            <span class="hidden md:inline">New Tenant</span>
                        </div>
                    </router-link>
                </header>

                <template v-if="meta.count > 0">
                    <occupants-list :occupants="occupants" />

                    <footer class="px-4 text-sm font-semibold rounded-b bg-grey-bg sm:px-6 text-grey-darker">
                        <base-pagination
                            v-model="page"
                            :per-page="meta.per_page"
                            :from="meta.from"
                            :to="meta.to"
                            :last-page="meta.last_page"
                            :count="meta.count"
                            :total="meta.total"
                            :is-disabled="is_loading"
                        />
                    </footer>
                </template>

                <div
                    v-else
                    class="relative py-16"
                >
                    <div class="max-w-sm px-6 mx-auto text-center">
                        <h2 class="mb-2 text-xl font-semibold">
                            Add your first tenant
                        </h2>

                        <div class="text-base text-grey-darker">
                            <p>You haven't added a tenant yet.</p>
                            <p class="md:hidden">
                                Tap <!--
                                --><base-svg
                                    name="icon-add-circle"
                                    class="inline w-4 h-4 -mt-1"
                                /><!--
                                --> above to get started.
                            </p>
                            <p class="hidden md:block">
                                Click "<!--
                                --><base-svg
                                    name="icon-add-circle"
                                    class="inline w-4 h-4 -mt-1"
                                /><!--
                                --> New Tenant" above to get started.
                            </p>
                        </div>
                    </div>

                    <base-svg
                        name="misc-arrow-up"
                        class="absolute top-0 right-0 w-4 mt-3 mr-8 sm:mr-10 md:mr-24 md:w-5 md:mt-4 fill-primary-blue-light"
                    />
                </div>
            </div>
        </div>
    </occupants-get>
</template>

<script>
    import PaginationMixin from '../../../../mixins/pagination'
    import OccupantsGet from '../../../../components/occupants-get'
    import OccupantsList from '../../../../components/occupants-list'

    export default {
        mixins: [
            PaginationMixin
        ],
        components: {
            OccupantsGet,
            OccupantsList
        }
    }
</script>
